// Toast Yapılandırması
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
});

const centerToast = Swal.mixin({
  position: "center",
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
  icon: "success",
});

function showCenterToast(message) {
  centerToast.fire({
    title: message,
  });
}

function showToast(type, message) {
  Toast.fire({
    icon: type,
    title: message,
  });
}


// product sayfasi custom color kismi editleme

function applyRalLabels() {

    const titleEl = document.querySelector('.m-product-title');
    if (!titleEl) return;

    const productTitle = titleEl.textContent.trim();

    // 🔒 Sadece Glazen Schuifwand içeren ürünlerde çalışsın
    if (!productTitle.includes("Glazen Schuifwand")) return;

    document.querySelectorAll('.main-product__block .m-product-option--node__label')
        .forEach((label) => {

            // Eğer zaten RAL eklenmişse tekrar ekleme
            if (label.nextElementSibling?.classList.contains('color-label')) return;

            const colorValue = window.getComputedStyle(label).backgroundColor;
            if (!colorValue) return;

            let ralText = "";

            if (colorValue.includes("74, 77, 79")) {
                ralText = "RAL7016";
            } 
            else if (colorValue.includes("213, 205, 190")) {
                ralText = "RAL9001";
            } 
            else if (colorValue.includes("255, 255, 255")) {
                ralText = "RAL9010";
            } 
            else if (colorValue.includes("15, 15, 15")) {
                ralText = "RAL9005";
            }

            if (ralText) {
                label.insertAdjacentHTML(
                    'afterend',
                    `<span class="color-label">${ralText}</span>`
                );
            }
        });
}

// İlk yükleme
document.addEventListener("DOMContentLoaded", applyRalLabels);

// Variant değişimini yakala
(function () {

    const pushState = history.pushState;
    const replaceState = history.replaceState;

    function onUrlChange() {
        setTimeout(applyRalLabels, 200);
    }

    history.pushState = function () {
        pushState.apply(history, arguments);
        onUrlChange();
    };

    history.replaceState = function () {
        replaceState.apply(history, arguments);
        onUrlChange();
    };

    window.addEventListener("popstate", onUrlChange);

})();


// product sayfasi app kismi ayarlama lenght hoogte



// function applyAcoDefaults() {
//   const inputBreedte = document.querySelector('input[name="field_1"]');
//   const inputLengte = document.querySelector('input[name="field_2"]');

//   if (inputBreedte && !inputBreedte.value) {
//     inputBreedte.value = 1000;
//     inputBreedte.dispatchEvent(new Event('input', { bubbles: true }));
//     inputBreedte.dispatchEvent(new Event('change', { bubbles: true }));
//   }

//   if (inputLengte && !inputLengte.value) {
//     inputLengte.value = 1000;
//     inputLengte.dispatchEvent(new Event('input', { bubbles: true }));
//     inputLengte.dispatchEvent(new Event('change', { bubbles: true }));
//   }
// }

// /* 1️⃣ İlk yükleme */
// document.addEventListener('DOMContentLoaded', () => {
//   applyAcoDefaults();

//   // 2️⃣ App geç yüklenirse diye TEK SEFERLİK gecikmeli deneme
//   setTimeout(applyAcoDefaults, 200); // 1 saniye ideal
// });

/* 3️⃣ Variant / URL değişimini izle */
let lastUrl = location.href;

// new MutationObserver(() => {
//   if (location.href !== lastUrl) {
//     lastUrl = location.href;

//     // ACO yeniden render olur → biraz bekle
//     setTimeout(applyAcoDefaults, 200);
//   }
// }).observe(document.body, {
//   childList: true,
//   subtree: true
// });




// custom wat guncelleme product variant degistiginde

